import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { studentAppSections } from "../../actprep-ui/constants/program";

export default function SectionLinkItemExtraFields({ formData, setFormData }) {
  return (
    <>
      <Grid size={12}>
        <FormControl fullWidth variant="standard" required>
          <InputLabel>Section</InputLabel>
          <Select
            value={formData.item_metadata?.section || ""}
            required
            label="Section"
            onChange={(event) =>
              setFormData((formData) => {
                formData.item_metadata.section = event.target.value;
                return { ...formData };
              })
            }
          >
            {Object.entries(studentAppSections).map(
              ([section, sectionTitle]) => (
                <MenuItem key={section} value={section}>
                  {sectionTitle}
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
}
